// src/pages/Home/Home.jsx
import React from "react";
import Banner from "../home/banner/HomeBanner";
import Services from "../home/services/HomeServicesSection";
import AboutUs from "../home/aboutus/HomeAboutUsSection";
import ChooseUs from "../home/chooseus/HomeWhyChooseUsSection";
import WorkProcess from "../home/workprocess/HomeWorkProcessSection";
import LogoCarousel from "./logosection/HomeLogoSections"
import OurTeam from "./ourteamsection/HomeOurTeamSection";

import "./Home.css";

const Home = () => {
  return (
    <div className="home-page">
      <Banner />
      {/* <LogoCarousel /> */}
      <Services />
      <WorkProcess />
      <AboutUs />
      <OurTeam />
      <ChooseUs />
      {/* Rest of your homepage content here */}
    </div>
  );
};

export default Home;